<div class="flex flex-align-center">
	<mat-checkbox [(ngModel)]="checkboxState" (change)="checkboxStateChanged()">{{
		params.label
	}}</mat-checkbox>
</div>
